import React, { useEffect, useRef } from "react"
import useFormField from "../../../../hooks/useFormField"
import FormFieldError from "../labels/form-field-error"
import FormInputLabel from "../labels/form-field-label"
import DatePickerPikaday from "../../../../styleguide/js/components/datepicker-pikaday"
import ToggleInfo from "../buttons/toggle-info-button"

export default function TextInput({
  name,
  id,
  label,
  placeholder,
  required,
  description,
  predefinedValue = "",
  validators = [],
  validateField,
  globalValue,
  setGlobalValue,
  setError,
  error,
  dateFormat,
  displayOption,
  closeModalLabel,
  moreInfoLabel,
}) {
  const { value, isFocused, handleFocus, handleBlur, handleChange, handleDateChange } = useFormField(
    predefinedValue,
    validateField,
    globalValue,
    setGlobalValue,
    setError,
  )

  const inputRef = useRef(null)
  const datePickerRef = useRef(null)

  const inputType = validators.some((v) => v.type === "EPiServer.Forms.Implementation.Validation.EmailValidator")
    ? "email"
    : validators.some((v) => v.Type === "EPiServer.Forms.Implementation.Validation.NumericValidator")
      ? "number"
      : validators.some((v) => v.Type === "EPiServer.Forms.Implementation.Validation.UrlValidator")
        ? "url"
        : "text"

  const isDateInput = validators.some((v) =>
    [
      "EPiServer.Forms.Implementation.Validation.DateDDMMYYYYValidator",
      "EPiServer.Forms.Implementation.Validation.DateMMDDYYYYValidator",
      "EPiServer.Forms.Implementation.Validation.DateYYYYMMDDValidator",
    ].includes(v.type),
  )

  const pattern = validators.find((v) => v.regexPattern)?.regexPattern || null

  useEffect(() => {
    if (isDateInput && inputRef.current) {
      datePickerRef.current = new DatePickerPikaday({ el: inputRef.current, format: dateFormat })
    }

    return () => {
      if (datePickerRef.current) {
        datePickerRef.current.getPicker().destroy()
      }
    }
  }, [isDateInput])

  return (
    <div
      ref={inputRef}
      className={`form-element Form__Element ${displayOption} ${isDateInput ? "form-element--date form-element--date--pikaday rm-this-class-hide-default" : "form-element--text"} 
       ${required ? "is-required " : ""} ${isFocused ? "has-focus" : ""} ${isFocused || value ? "is-filled" : ""} ${error ? "is-invalid" : ""}`}
      data-f-element-name={name}
      data-f-type={inputType === "url" ? "url" : "textbox"}
    >
      <div className="form-labels">
        <FormInputLabel id={id} label={label} required={required} />
        <ToggleInfo description={description} id={id} closeModalLabel={closeModalLabel} moreInfoLabel={moreInfoLabel} />
      </div>
      <input
        name={name}
        id={id}
        type={inputType}
        className="form-input"
        required={required}
        aria-required={required}
        data-f-datainput=""
        value={value || ""}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={isDateInput ? (e) => handleDateChange(e) : handleBlur}
        aria-describedby={`${name}_desc`}
        pattern={pattern || undefined}
        title={description}
        aria-label={description + (placeholder != null ? " " + placeholder : "")}
        aria-invalid={!!error}
        autoComplete={isDateInput ? "off" : "on"}
      />
      <FormFieldError name={name} error={error} placeholder={placeholder} />
    </div>
  )
}
